import type { FirebaseFunctionsError } from "../types"

// Common error keys every Firebase Functions caller has to handle. Each call
// site layers its own specific cases (e.g. `unknownEmail`, `invalidState`) on
// top via the `cases` map.
type CommonErrorKey = "network" | "generic"

// Maps a Firebase Functions error to a translation key. Lets each caller
// declare its own specific cases by Firebase code while delegating the
// network/generic fallbacks here so both flows agree.
export const mapFirebaseFunctionsError = <K extends string>(
  error: unknown,
  cases: Partial<Record<string, K>> = {},
): K | CommonErrorKey => {
  const code = (error as FirebaseFunctionsError | null)?.code
  if (code) {
    const mapped = cases[code]
    if (mapped) return mapped
    if (code === "functions/unavailable") return "network"
  }
  return "generic"
}
